import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col } from "react-bootstrap";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import { FaClock } from "react-icons/fa";

const EmployeeTimesheetLanding = () => {
  const navigate = useNavigate();
  const employeeId = localStorage.getItem("employeeId");

  // ✅ Function to navigate with employeeId
  const handleGoToTimesheet = () => {
    navigate("/timesheetgrid", { state: { employeeId } });
  };

  const timesheetLinks = [
    {
      name: "My Timesheets",
      icon: <FaClock size={22} className="text-dark" />,
      onClick: handleGoToTimesheet,
    },
  ];

  // 🔐 Authentication check
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // ✅ Load Bootstrap dynamically
  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(iconsLink);

    return () => {
      bootstrapLink.remove();
      iconsLink.remove();
    };
  }, []);

  return (
    <>
      {/* 🔹 Fixed Navbar */}
      <div className="fixed-top">
        <EmployeeNavbar />
      </div>

      {/* 🔹 Full Page */}
      <div
        className="timesheet-page"
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(135deg, #eef1f7 0%, #ffffff 100%)",
          paddingTop: "140px",
          paddingBottom: "60px",
        }}
      >
        <div className="container-fluid px-5">
          <Row className="align-items-center g-5">
            {/* 🟢 LEFT COLUMN - Info Section */}
            <Col
              xs={12}
              md={5}
              className="d-flex flex-column justify-content-center text-center text-md-start"
            >
              <h1 className="fw-bold mb-3 text-dark">Timesheet Overview</h1>
              <p
                className="text-secondary fs-5"
                style={{
                  textAlign: "justify",
                  lineHeight: "1.7",
                  maxWidth: "600px",
                }}
              >
                Record and manage your working hours effortlessly. The Timesheets
                module enables you to log daily tasks, review project
                contributions, and keep track of timelines — all from your
                employee dashboard. Stay organized, accurate, and always on time.
              </p>
            </Col>

            {/* 🔵 RIGHT COLUMN - Small Icon Cards */}
            <Col xs={12} md={7}>
              <Row xs={2} sm={3} md={3} lg={4} className="g-3 justify-content-md-start justify-content-center">
                {timesheetLinks.map((item, idx) => (
                  <Col key={idx}>
                    <div
                      className="small-card text-center shadow-sm border-0 py-3 px-2"
                      onClick={item.onClick}
                      style={{
                        cursor: "pointer",
                        borderRadius: "12px",
                        background: "#fff",
                        transition: "all 0.25s ease",
                      }}
                    >
                      <div className="mb-2">{item.icon}</div>
                      <h6 className="fw-semibold mb-0">{item.name}</h6>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        {/* 🎨 Hover Styles */}
        <style>
          {`
            .small-card:hover {
              transform: translateY(-4px) scale(1.03);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
            h6 {
              font-size: 0.95rem;
            }
          `}
        </style>
      </div>
    </>
  );
};

export default EmployeeTimesheetLanding;
